export default class SearchPage {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;

    this.searchForm = this.element.querySelector('#search-page-form');
    this.searchInput = this.element.querySelector('#search_text');

    this.loadSearchPage();
  }

  loadSearchPage = () => {
    // Remove trailing '*' character from search input.
    const removeStar = this.searchInput.value.replace(/\*$/, '');
    this.searchInput.value = removeStar;
  }
}
